// LevelLoaderContext.tsx
import type React from "react";
import {createContext, useContext, useState} from "react";

interface LevelLoaderContextType {
  lastLevelId: string | null;
  setLastLevelId: (id: string | null) => void;
}

const LevelLoaderContext = createContext<LevelLoaderContextType | undefined>(
  undefined,
);

export const LevelLoaderProvider: React.FC<{children: React.ReactNode}> = ({
  children,
}) => {
  const [lastLevelId, setLastLevelId] = useState<string | null>(null);

  return (
    <LevelLoaderContext.Provider value={{lastLevelId, setLastLevelId}}>
      {children}
    </LevelLoaderContext.Provider>
  );
};

export const useLevelLoaderContext = () => {
  const context = useContext(LevelLoaderContext);
  if (context === undefined) {
    throw new Error(
      "useLevelLoaderContext must be used within a LevelLoaderProvider",
    );
  }
  return context;
};
